import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-notification-header',
  standalone: true,
  imports: [],
  templateUrl: './notification-header.component.html',
  styleUrl: './notification-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
// eslint-disable-next-line @tseslint/no-extraneous-class
export class NotificationHeaderComponent {}
